export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15101.10e90bd8.jpg";